import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Logo from "./partials/Logo";
import FooterNav from "./partials/FooterNav";
import FooterSocial from "./partials/FooterSocial";
import { Typography, Divider } from '@material-ui/core';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    "site-footer center-content-mobile",
    topOuterDivider && "has-top-divider",
    className
  );

  return (
    <footer {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-footer-inner",
            topDivider && "has-top-divider"
          )}
        >
          <div className="footer-top space-between text-xxs">
            <Logo />
            <FooterSocial />
          </div>
          <div className="footer-bottom space-between text-xxs invert-order-desktop">

            <div className="footer-copyright">
              © 2021 Pay Your Tuition Foundation, Inc
              <Divider />

              <div className="footer-copyright" style={{ fontSize: "12px" }}
              >
                Pay Your Tuition Foundation, Inc. is a licensed 501(3)(c) organization (EIN#85-3432471) with a registered address at
          <br></br>712 H Street NE, Ste #557, Washington DC 20002. Registered in DE under #3853692.
        </div>

            </div>



          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
